<template>
  <v-simple-table class="elevation-0 mb-4">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-center" />
          <th class="text-left">COMPETÊNCIA</th>
          <th class="text-center">RESULTADO</th>
          <th class="text-center">RESULTADO MÁXIMO</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="indicacao in sortIndicacoesTalento(indicacoesTalento)"
          :key="indicacao.id"
        >
          <td width="5%">
            <v-icon color="yellow darken-3">emoji_events</v-icon>
          </td>
          <td>
            <span class="grey--text text--darken-2">{{
              indicacao.competencia.nome
            }}</span>
          </td>
          <td class="text-center" width="10%">
            <span class="success--text">
              <strong>{{ indicacao.notaAgrupada | decimal }}</strong>
            </span>
          </td>
          <td class="text-center" width="10%">
            <span class="grey--text text--darken-2">
              <strong>{{ indicacao.notaMaxima | decimal }}</strong>
            </span>
          </td>
        </tr>
        <tr
          v-for="indicacao in sortIndicacoesDesenvolvimento(
            indicacoesDesenvolvimento
          )"
          :key="indicacao.id"
        >
          <td width="5%">
            <v-icon color="error">trending_up</v-icon>
          </td>
          <td>
            <span class="grey--text text--darken-2">{{
              indicacao.competencia.nome
            }}</span>
          </td>
          <td class="text-center" width="10%">
            <span class="error--text">
              <strong>{{ indicacao.notaAgrupada | decimal }}</strong>
            </span>
          </td>
          <td class="text-center" width="10%">
            <span class="grey--text text--darken-2">
              <strong>{{ indicacao.notaMaxima | decimal }}</strong>
            </span>
          </td>
        </tr>
        <tr>
          <td class="text-center" colspan="6">
            <v-row class="justify-center">
              <v-col>
                <v-icon class="mr-2" color="yellow darken-3">
                  emoji_events
                </v-icon>
                Indicação de Talento
                <v-icon class="ml-8 mr-2" color="error"> trending_up </v-icon>
                Indicação de Desenvolvimento
              </v-col>
            </v-row>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: 'AppIndicacao',

  props: {
    indicacoesTalento: {
      type: Array,
      default: () => [],
    },
    indicacoesDesenvolvimento: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    sortIndicacoesTalento(indicacoes) {
      return indicacoes.sort((a, b) => {
        if (a.ordemIndicacao > b.ordemIndicacao) {
          return 1;
        }
        if (a.ordemIndicacao < b.ordemIndicacao) {
          return -1;
        }
        return 0;
      });
    },
    sortIndicacoesDesenvolvimento(indicacoes) {
      return indicacoes.sort((a, b) => {
        if (a.ordemIndicacao > b.ordemIndicacao) {
          return 1;
        }
        if (a.ordemIndicacao < b.ordemIndicacao) {
          return -1;
        }
        return 0;
      });
    },
  },
};
</script>
